import React from "react";

const Popover = (props) => (
  <div className={`popover bs-popover-bottom border-0 ${props.className}`}>
    <div className="arrow"></div>
    <div className={localStorage.logged ? 'popover-body p-4' : 'popover-body'}>
      {props.content}
    </div>
  </div>
);

export default Popover;


// WEBPACK FOOTER //
// ./src/components/Popover.js